document.addEventListener('DOMContentLoaded', function() {

  //look for shortcodes in the content
  const elements = document.querySelectorAll('[data-lr-efcg-klaviyo-listid]');

  //if shortcode exists
  if(elements.length > 0) {

    //loop through each shortcode and create a new form
    elements.forEach(element => {

      const listId = element.getAttribute('data-lr-efcg-klaviyo-listid');
      const title = element.getAttribute('data-lr-efcg-klaviyo-title');
      const image = element.getAttribute('data-lr-efcg-background-image-url');
      const imageAlt = element.getAttribute('data-lr-efcg-background-image-alt');

      // Select the template with data-klaviyo-form-container
      const template = document.querySelector('template[data-klaviyo-form-container-template]');
      if (template) {
        // Clone the template content
        const clone = document.importNode(template.content, true);

        // Create a new div element to hold the cloned content
        const newElement = document.createElement('div');
        newElement.appendChild(clone);

        // Update the data-attribute values in the new element
        const clonedElement = newElement.querySelector('[data-klaviyo-form-container]');

        if (clonedElement) {

          clonedElement.querySelector('[data-klaviyo-form-image]').src = image;
          clonedElement.querySelector('[data-klaviyo-form-image]').alt = imageAlt;
          clonedElement.querySelector('[data-klaviyo-form-title]').textContent = title;
          clonedElement.querySelector('[data-klaviyo-form-id]').value = listId;
        }

        // Append the new element after the current element
        element.insertAdjacentElement('afterend', newElement);
      }
    });

    // Add event listener to the form
    document.querySelectorAll(".lr-efcg-email-form").forEach( function(form) {
      form.addEventListener("submit", function(event) {
          event.preventDefault();
          const emailInput = form.querySelector(".lr-efcg-email-form-input");
          const listIdInput = form.querySelector("[data-klaviyo-form-id]").value;
          const errorMessage = form.querySelector(".lr-efcg-validation");
          const email = emailInput.value.trim();


          // Basic email validation using regex
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if (!emailPattern.test(email)) {
              errorMessage.textContent = "Please enter a valid email address.";
              return;
          } else {
              errorMessage.textContent = "";
          }

          // Send valid email to Klaviyo
          submitEmailToKlaviyoProxy(email, form, listIdInput);
      });
    });

    // Function to submit email to Klaviyo
    function submitEmailToKlaviyoProxy(email, form, list_id) {
        const url = 'https://hooks.zapier.com/hooks/catch/14839739/21bhs10/';
        const messageContainer = form.querySelector(".lr-efcg-validation");

        const data = {
            email: email,
            list_id: list_id
        };

        fetch(url, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(() => {
                messageContainer.textContent = "Success! Our care guide is on its way to your inbox.";
                dataLayer.push({'event': 'efcg-email-submit'});
            })
            .catch(error => {
                console.error("Error:", error);
                messageContainer.textContent = "There was a problem submitting your email.";
            });
    }
  }
});